export const MODULE_NAME = 'UNIT_TYPE_GROUP_MODULE';
